import {
  SET_ACTIVE_PROGRAM_DETAILS,
  SET_ALL_PROGRAM_DETAILS,
} from '../constants';

export const setActiveProgram = (program) => {
  return {
    type: SET_ACTIVE_PROGRAM_DETAILS,
    payload: program,
  };
};

export const setAllProgramsToStore = (allPrograms) => {
  return {
    type: SET_ALL_PROGRAM_DETAILS,
    payload: allPrograms,
  };
};
